import React, { createContext, useContext } from 'react';

import type { MiniDrawerContextValue } from '~/components/core/MiniDrawer/types';

const MiniDrawerContext = createContext<MiniDrawerContextValue>({
  isExpanded: false,
  expandedWidth: 0,
  collapsedWidth: 0,
  transitionDuration: 0,
  iconSize: 0,
});

export interface MiniDrawerProviderProps {
  children: React.ReactNode;
  value: MiniDrawerContextValue;
}

export const MiniDrawerProvider: React.FC<MiniDrawerProviderProps> = ({ children, value }) => {
  return <MiniDrawerContext.Provider value={value}>{children}</MiniDrawerContext.Provider>;
};

export const useMiniDrawer = (): MiniDrawerContextValue => {
  return useContext(MiniDrawerContext);
};
